import { useState } from "react";
import { Modal } from "react-bootstrap";
import { setSpeeds } from "utils";

const ViewDetailsModal: React.FC<{ copy: string; card: any }> = ({ copy, card }) => {
  const [showViewDetailsModal, setShowViewDetailsModal] = useState(false);

  const formattedTextWithSpeedUnits = setSpeeds(copy, card);

  return (
    <>
      <div className='card-view-details mt-3 mb-5'>
        <button onClick={() => setShowViewDetailsModal(true)}>View Details</button>
      </div>
      <Modal show={showViewDetailsModal} onHide={() => setShowViewDetailsModal(false)} className='card-view-deails-modal'>
        <Modal.Header closeButton>
          <Modal.Title>Product Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div dangerouslySetInnerHTML={{ __html: formattedTextWithSpeedUnits }} className='card-view-details-content' />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ViewDetailsModal;
